import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { TextStyleProp, AlertType } from '../alerts/types';

const getBorderLeftColor = (type: AlertType) => {
  if (type === 'error') return theme.colors.status.critical;
  if (type === 'info') return theme.colors.primary50;
  if (type === 'success') return theme.colors.status.success;
  return theme.colors.status.warning;
};

const textStyle = ({ type }: TextStyleProp) => {
  const spacing = theme.spacing;
  const borderRadius = theme.borderRadius.medium;
  const borderLeftColor = getBorderLeftColor(type);

  return css`
    display: flex;
    align-items: center;
    margin: 0;
    padding: ${spacing(2, 2, 2, 1.5)};

    ::before {
      content: '';
      width: 4px;
      height: 100%;

      background: ${borderLeftColor};
      border-top-left-radius: ${borderRadius};
      border-bottom-left-radius: ${borderRadius};
      display: block;
      position: absolute;
      top: 0;
      left: 0;
    }

    svg {
      min-width: 24px;
      margin-right: ${spacing(1)};
    }
  `;
};

const containerStyleObject = css`
  width: 100%;
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.small};
  box-shadow: ${theme.shadows.heavy};
  cursor: pointer;
  overflow: hidden;
  position: relative;
  pointer-events: all;
  z-index: ${theme.zIndex.low};
`;

export const deprecated_AlertStyles = {
  textStyle: (textStyleProps: TextStyleProp) => textStyle(textStyleProps),
  containerStyle: containerStyleObject,
};
